import * as React from 'react';
import {
  createFileRoute,
  Link,
  Outlet,
  useNavigate,
} from '@tanstack/react-router';
import { SplitterMenu } from '../../components/ui/layout/page/splitterMenu/SplitterMenu';
import { ReactNode, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useHierarchyEndpoint } from '~/api/useHierarchyEndpoint';

export const Route = createFileRoute('/_authLayout/obligations')({
  component: ObligationsComponent,
});

function ObligationsComponent() {
  const [menu, setMenu] = React.useState<ReactNode | null>(null);

  const auth = useAuth();
  const navigate = useNavigate();
  const { fundHierarchy } = useHierarchyEndpoint();
  if (!auth.isSignedIn && auth.isLoaded) {
    navigate({ to: '/sign-in' });
  }

  useEffect(() => {
    if (fundHierarchy) {
      setMenu(
        fundHierarchy.map((item) => (
          <p>
            <Link
              title={item.legalJurisdiction.name}
              href={`/obligations/list/${item.legalJurisdiction.jurisdiction}`}
            >
              {item.legalJurisdiction.name}
            </Link>
          </p>
        )),
      );
    }
  }, [fundHierarchy]);
  return (
    <SplitterMenu title="Obligations" menu={menu} isMenuOpen={true}>
      <Outlet />
    </SplitterMenu>
  );
}
